import request from '@/utils/request'

// 查询人员情况列表
export function listPersonnelstatus(query) {
  return request({
    url: '/screen/creditlibrary/personnelstatus/list',
    method: 'get',
    params: query
  })
}

// 查询人员情况详细
export function getPersonnelstatus(pid) {
  return request({
    url: '/screen/creditlibrary/personnelstatus/detail/' + pid,
    method: 'get'
  })
}

// 新增人员情况
export function addPersonnelstatus(data) {
  return request({
    url: '/screen/creditlibrary/personnelstatus/add',
    method: 'post',
    data: data
  })
}

// 修改人员情况
export function updatePersonnelstatus(data) {
  return request({
    url: '/screen/creditlibrary/personnelstatus/edit',
    method: 'post',
    data: data
  })
}

// 删除人员情况
export function delPersonnelstatus(pid) {
  return request({
    url: '/screen/creditlibrary/personnelstatus/delete/' + pid,
    method: 'get'
  })
}
